import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, Scene } from 'react-scrollmagic';

import BrandedIcon from './icons/branded';
import DeliverIcon from './icons/deliver';
import DevicesIcon from './icons/devices';
import ManageIcon from './icons/manage';
import SectionTitle from './section-title';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(23, 0),
    '& .d0': {
      transitionDelay: '0.4s'
    },
    '& .d1': {
      transitionDelay: '0.7s'
    },
    '& .d2': {
      transitionDelay: '1.0s'
    },
    '& .d3': {
      transitionDelay: '1.3s'
    }
  },
  animate: {
    position: 'relative',
    top: 20,
    transition:
      'opacity 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955), top 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955)',
    opacity: 0
  },
  show: {
    top: 0,
    opacity: 1
  },
  title: {
    transitionDelay: '0.1s'
  },
  content: {
    height: '100%',
    minHeight: 204,
    padding: theme.spacing(7, 6, 6),
    backgroundColor: theme.palette.background.paper,
    borderRadius: 16,
    boxShadow: '0px 8px 32px #BDD7F0',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(8)
    }
  },
  icon: {
    display: 'block',
    width: 84,
    margin: '0 auto',
    marginBottom: theme.spacing(8.5),
    '& svg': {
      fontSize: 84
    },
    [theme.breakpoints.up('md')]: {
      margin: 0,
      marginRight: theme.spacing(7)
    }
  },
  text: {
    [theme.breakpoints.up('md')]: {
      flex: '1 0',
      width: '100%'
    }
  }
}));

const data = [
  {
    icon: <DeliverIcon />,
    text: 'whiteLabelPage.Augmented_Reality.text1'
  },
  {
    icon: <DevicesIcon />,
    text: 'whiteLabelPage.Augmented_Reality.text2'
  },
  {
    icon: <BrandedIcon />,
    text: 'whiteLabelPage.Augmented_Reality.text3'
  },
  {
    icon: <ManageIcon />,
    text: 'whiteLabelPage.Augmented_Reality.text4'
  }
];

const AugmentedRealityContent = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <section className={classes.root}>
      <Container maxWidth="xl">
        <Controller>
          <Scene
            classToggle={[`.${classes.animate}`, `${classes.show}`]}
            triggerElement="#whiteLabelAR"
            indicators={false}
            reverse={false}
          >
            <div id="whiteLabelAR">
              <SectionTitle
                className={clsx(classes.title, classes.animate)}
                title={t('whiteLabelPage.Augmented_Reality.title')}
              />
              <Grid container spacing={10}>
                {data.map((item, indx) => {
                  return (
                    <Grid
                      key={indx}
                      item
                      xs={12}
                      sm={6}
                      className={clsx(`d${indx}`, classes.animate)}
                    >
                      <div className={classes.content}>
                        <i className={classes.icon}>{item.icon}</i>
                        <Typography
                          className={classes.text}
                          variant="body1"
                          align={matches ? 'left' : 'center'}
                        >
                          {t(item.text)}
                        </Typography>
                      </div>
                    </Grid>
                  );
                })}
              </Grid>
            </div>
          </Scene>
        </Controller>
      </Container>
    </section>
  );
};

export default AugmentedRealityContent;
